const SCHEMA_OPTIONS_MAP = {
  3: [{ value: "rpsl", label: "ksm" }],
  default: [
    { value: "lsfhp", label: "สัญญา 1" },
    { value: "vsfhp", label: "สัญญา 2" },
    { value: "psfhp", label: "สัญญา 3" },
    { value: "rpsl", label: "สัญญา 3(ใหม่)" },
    { value: "sfhp", label: "สัญญา 8" },
  ],
};

export function getSchemaContractOptions(userCompany) {
  return SCHEMA_OPTIONS_MAP[userCompany] ?? SCHEMA_OPTIONS_MAP.default;
}
